import React from "react";

export function lazyWithPreload<T extends React.ComponentType<any>>(
  factory: () => Promise<{ default: T }>
): React.LazyExoticComponent<T> & { preload: () => Promise<{ default: T }> } {
  const Component = React.lazy(factory);

  // attach preload method
  (Component as any).preload = factory;

  return Component as React.LazyExoticComponent<T> & { preload: () => Promise<{ default: T }> };
}

